module.exports = __webpack_public_path__ + "img/5c857d6.jpg";